import PaymentLinkIcon from '@mui/icons-material/AttachMoney';
import PaymentLinkList from './list';
import PaymentLinkCreate from './create';
import PaymentLinkShow from './show';
import PaymentLinkEdit from './edit';
import PaymentRequest from './payment-request';
/* import PaymentLinkEdit from './edit';
import PaymentLinkShow from './single' */


export default {
    list: PaymentLinkList,
    create: PaymentLinkCreate,
    show: PaymentLinkShow,
    edit: PaymentLinkEdit,
/*     edit: PaymentLinkEdit,
 */    icon: PaymentLinkIcon,
/*     show: PaymentLinkShow
 */};